import LockFill from './LockFill';

export default LockFill;
